/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type { CustomisationResponse, UpsertCustomisationRequest } from '../dto'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class DocumentController<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags document-controller
   * @name FindCustomisationByType
   * @request GET:/api/v1/documents/customisations/{customisationType}
   */
  findCustomisationByType = (
    customisationType: 'CONVERT_RECEIPT_IN_EMAIL_BODY_TO_PDF',
    params: RequestParams = {},
  ) =>
    this.http.request<CustomisationResponse, any>({
      path: `/v1/documents/customisations/${customisationType}`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static findCustomisationByTypePath = '/v1/documents/customisations/${customisationType}'
  static findCustomisationByTypeMethod = 'GET'
  /**
   * No description
   *
   * @tags document-controller
   * @name UpsertCustomisation
   * @request PUT:/api/v1/documents/customisations/{customisationType}
   */
  upsertCustomisation = (
    customisationType: 'CONVERT_RECEIPT_IN_EMAIL_BODY_TO_PDF',
    data: UpsertCustomisationRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<CustomisationResponse, any>({
      path: `/v1/documents/customisations/${customisationType}`,
      method: 'PUT',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static upsertCustomisationPath = '/v1/documents/customisations/${customisationType}'
  static upsertCustomisationMethod = 'PUT'
  /**
   * No description
   *
   * @tags document-controller
   * @name FindCustomisations
   * @request GET:/api/v1/documents/customisations
   */
  findCustomisations = (params: RequestParams = {}) =>
    this.http.request<CustomisationResponse[], any>({
      path: `/v1/documents/customisations`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static findCustomisationsPath = '/v1/documents/customisations'
  static findCustomisationsMethod = 'GET'
}
